<div class="row mt-3 mx-5 ttlborder" *ngIf="performanceAreas && performanceAreas.length > 0">
  <div class="w-100 overflow-x" aria-describedby="PerformanceMeasuresTable">
  <table mat-table id="PerformanceMeasuresTable" [dataSource]="dataSource" class="tblscroll">
      <ng-container matColumnDef="header-row-performance">
        <th mat-header-cell *matHeaderCellDef class="borderRad">
          <div class="mat-subheading-1 text-left heading-color">
            <p class="header-mat-panel-title mat-subheading-1">ODP Monitored Performance Measures</p>
          </div>
        </th>
      </ng-container>
      <ng-container matColumnDef="content">
        <td mat-cell *matCellDef="let _">
          <div class="performance-data">
            <div *ngFor="let area of performanceAreas; let areaIndex = index" class="performance-area">
              <div class="expandable-row level-1" (click)="toggleArea(areaIndex)">
                <div class="row-content">
                  <div class="row-left">
                    <span class="expand-arrow" [class.expanded]="area.expanded"></span>
                    <span class="row-title">{{area.performanceAreaTitle}}: {{area.performanceAreaDescription}}</span>
                  </div>
                  <div class="row-badges">
                    <span class="badge badge-total">Total Measures: {{getTotalMeasures(area)}}</span>
                  </div>
                </div>
              </div>
              <div class="nested-content level-2" [class.expanded]="area.expanded">
                <div *ngFor="let measure of area.measures; let measureIndex = index; trackBy: trackMeasure" class="measure-row">
                  <div class="expandable-row individual-measure"
                       [class.expanded]="measure.expanded"
                       role="button"
                       tabindex="0"
                       [attr.aria-expanded]="measure.expanded"
                       (click)="toggleMeasure(areaIndex, measureIndex)"
                       (keydown.enter)="toggleMeasure(areaIndex, measureIndex)"
                       (keydown.space)="toggleMeasure(areaIndex, measureIndex)">
                    <div class="row-content">
                      <div class="row-left">
                        <span class="expand-arrow" [class.expanded]="measure.expanded"></span>
                        <div class="measure-content">
                          <span class="measure-title">
                            <span class="measure-label">Measure {{measure.measureTitle}}:  </span>
                            <span class="measure-desc-text">
                               {{measure.measureDescription}}
                            </span>
                          </span>
                        </div>
                      </div>
                      <div class="row-badges">
                        <span class="badge"
                          *ngIf="measure?.isMeasureMet !== null && measure?.isMeasureMet !== undefined"
                          [ngClass]="measure.isMeasureMet ? 'badge-met' : 'badge-unmet'">
                          Measure {{ measure.isMeasureMet ? 'Met' : 'Unmet' }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="nested-content level-3" [class.expanded]="measure.expanded" *ngIf="measure.outcomes && measure.outcomes.length > 0">
                    <div class="outcomes-block">
                      <div class="outcomes-header">SCO Performance</div>
                      <div class="outcomes-list">
                        <div class="outcome-row" *ngFor="let outcome of measure.outcomes">
                          <div class="outcome-desc">
                            <span class="outcome-desc" [innerHtml]="outcome.outcomeDescription"></span>
                            <span class="outcome-inline-percentage"> {{outcome.outcomePercentage}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row class="tableHeading" *matHeaderRowDef="['header-row-performance']; sticky: true"></tr>
      <tr mat-row *matRowDef="let element; columns: ['content']" class="example-element-row"></tr>
    </table>
  </div>
</div>
<div class="row mt-3 mx-5 ttlborder" *ngIf="performanceAreas && performanceAreas.length === 0">
  <div class="no-data-msg w-100 p-3">No performance measures available.</div>
</div>
